exports = module.exports = require("../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".indexSelection{margin-top:10px;margin-bottom:15px}.indexSelection .form-group{width:400px}.deflist{margin-top:10px}.deflist dt{float:left;clear:left}.deflist dd{margin-left:150px;word-wrap:break-word}.deflistWide dd{margin-left:200px}.archives-form{margin-top:10px}.limited-table{max-height:170px;overflow:auto}.limited-table table{margin-bottom:0}.input-horizontal-form-wrapper{line-height:20px;padding-top:7px}.stream-selector{padding-bottom:7px;padding-top:5px}.reset-button-container{padding-left:0}.scrollable-list-container{position:relative}.scrollable-list{max-height:425px;overflow-y:auto}.scrollable-list-header{position:absolute;left:0;right:0;top:0;display:block;z-index:10}.scrollable-list-item:nth-child(2){margin-top:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/node_modules/css-loader!./src/web/style.css
// module id = 553
// module chunks = 0